import React from 'react';
import { FlagIcon } from './UI';
export const Footer = () => {
  return <footer className="bg-[#0a0a0a] border-t border-dark-3" data-id="element-110">
      {/* Top Section */}
      <div className="container mx-auto px-6 md:px-12 py-[80px] pb-[60px]" data-id="element-111">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-112">
          {/* Col 1 - Brand */}
          <div data-id="element-113">
            <div className="flex items-center gap-3 mb-3" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/gtew43sgjbWAUi8V7My12k/hf_20260505_154603_f5f185ee-8480-4693-8c47-91f27540bf0d.png" alt="Blackout Unit Logo" className="w-14 h-14 object-contain" data-id="element-115" />
              <div data-id="element-116">
                <div className="font-bebas text-2xl tracking-wider text-white leading-none" data-id="element-117">
                  BLACKOUT <span className="text-acid-green" data-id="element-118">UNIT™</span>
                </div>
                <div className="font-barlow font-bold text-[9px] text-acid-green tracking-[3px] uppercase mt-1" data-id="element-119">
                  EST. 2019
                </div>
              </div>
            </div>
            <div className="font-barlow text-sm text-white tracking-widest uppercase mb-6" data-id="element-120">
              Built by Operators. For Operators.
            </div>
            <p className="font-inter text-xs text-text-dimmed leading-relaxed mb-6 pr-4" data-id="element-121">
              "We spent two years building the mask the industry refused to
              make. This is it. No compromises. No cheap materials. No apologies
              for the standard we hold."
            </p>
            <div className="flex gap-3" data-id="element-122">
              {['IG', 'TT', 'YT', 'FB', 'X'].map(social => <a key={social} href="#" className="w-8 h-8 bg-dark-1 border border-dark-3 flex items-center justify-center text-xs font-barlow text-text-dimmed hover:text-acid-green hover:border-acid-green transition-colors" data-id="element-123">
                  {social}
                </a>)}
            </div>
          </div>

          {/* Col 2 - Arsenal */}
          <div data-id="element-124">
            <h4 className="font-bebas text-xl text-white mb-6" data-id="element-125">ARSENAL</h4>
            <ul className="space-y-3 font-inter text-sm text-text-dimmed" data-id="element-126">
              <li data-id="element-127">
                <a href="#the-mask" className="hover:text-acid-green transition-colors" data-id="element-128">
                  Ultimate Mask
                </a>
              </li>
              <li data-id="element-129">
                <a href="#arsenal" className="hover:text-acid-green transition-colors" data-id="element-130">
                  Individual Lens Packs
                </a>
              </li>
              <li data-id="element-131">
                <a href="#bundles" className="hover:text-acid-green transition-colors" data-id="element-132">
                  The Ghost Bundle
                </a>
              </li>
              <li data-id="element-133">
                <a href="#bundles" className="hover:text-acid-green transition-colors" data-id="element-134">
                  The Operator Bundle
                </a>
              </li>
              <li data-id="element-135">
                <a href="#bundles" className="hover:text-acid-green transition-colors" data-id="element-136">
                  The Squad Bundle
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3 - Support */}
          <div data-id="element-137">
            <h4 className="font-bebas text-xl text-white mb-6" data-id="element-138">SUPPORT</h4>
            <ul className="space-y-3 font-inter text-sm text-text-dimmed" data-id="element-139">
              <li data-id="element-140">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-141">
                  FAQ
                </a>
              </li>
              <li data-id="element-142">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-143">
                  Shipping Info
                </a>
              </li>
              <li data-id="element-144">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-145">
                  Warranty Policy
                </a>
              </li>
              <li data-id="element-146">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-147">
                  Returns & Exchanges
                </a>
              </li>
              <li data-id="element-148">
                <a href="#contact" className="hover:text-acid-green transition-colors" data-id="element-149">
                  Contact Us
                </a>
              </li>
              <li className="pt-2" data-id="element-150">
                <a href="tel:+18000000000" className="text-acid-green font-bebas text-lg tracking-wider" data-id="element-151">
                  +1 (800) 000-0000
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4 - Company */}
          <div data-id="element-152">
            <h4 className="font-bebas text-xl text-white mb-6" data-id="element-153">COMPANY</h4>
            <ul className="space-y-3 font-inter text-sm text-text-dimmed" data-id="element-154">
              <li data-id="element-155">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-156">
                  Our Mission
                </a>
              </li>
              <li data-id="element-157">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-158">
                  Why We Built This
                </a>
              </li>
              <li data-id="element-159">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-160">
                  For Teams & Wholesale
                </a>
              </li>
              <li data-id="element-161">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-162">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-163">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-164">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-black/50 py-5 px-6 md:px-12 border-t border-dark-3 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-165">
        <div className="font-inter text-xs text-text-dimmed text-center md:text-left flex items-center gap-2 flex-wrap justify-center" data-id="element-166">
          <span data-id="element-167">
            © 2025 BLACKOUT UNIT™ | blackoutunit.com | All Rights Reserved
          </span>
          <FlagIcon className="w-4 h-3" data-id="element-168" />
        </div>
        <div className="flex gap-2" data-id="element-169">
          {['VISA', 'MC', 'AMEX', 'PAYPAL', 'SHOP PAY', 'APPLE PAY'].map(pay => <div key={pay} className="bg-dark-1 border border-dark-3 px-2 py-1 text-[9px] font-barlow text-text-dimmed rounded-sm" data-id="element-170">
                {pay}
              </div>)}
        </div>
      </div>
    </footer>;
};